module.exports = "<a href=\"javascript:void(0);\" *ngIf=\"show\">{{Yiit.t('Home')}}</a>\n"